import { render, staticRenderFns } from "./server-administration.vue?vue&type=template&id=3cc7cce9&"
import script from "./server-administration.vue?vue&type=script&lang=js&"
export * from "./server-administration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports